/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.support").
controller("DxSupportPinController", function SupportPinController(
	$scope,

	dxApi
) {
	"use strict";

	var self = this;

	this.userPin = "";
	this.showError = false;

	$scope.requestSupportPin = function requestSupportPin() {
		dxApi.v1.users.pin.get(self.userId).then(onGetSucess, onGetError);

		function onGetSucess(data) {
			self.userPin = data.pin;
		}

		function onGetError() {
			self.showError = true;
		}
	};

	$scope.requestSupportPin();
});
